import { render } from "./IconPin.vue?vue&type=template&id=81e2d894"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconPin.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "81e2d894"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('81e2d894', __exports__)) {
    api.reload('81e2d894', __exports__)
  }
  
  module.hot.accept("./IconPin.vue?vue&type=template&id=81e2d894", () => {
    api.rerender('81e2d894', render)
  })

}


export default __exports__